import React, { useContext } from "react";
import "../../styles/pages/Editor.scss";
import homebtn from "../../images/Homebtn.svg";
import Tooltip from "@mui/material/Tooltip";
import ValueContext from "../../ContextAPi/appContext";
import { useHistory } from "react-router-dom";
const BannerPreviewHeader = ({ editorProps, setShowConfirmation }) => {
    const history = useHistory();
    const appData = useContext(ValueContext);

    const confirmCancel = () => {
        setShowConfirmation(true)
    }

    const goToHome = () => {
        appData.setBanner(
            true
        );
        history.push("/");

    }

    return (
        <>
            <div className="container-fluid editorTempheader">
                <div className="row editHeader" style={{ alignItems: "center" }}>
                    <div className="col-md-3 d-flex tempHeaderLeft">
                        <div className="contstud-title">
                            <div className=" d-flex editorHeading">
                                <div className=" d-flex editorTempHeading">
                                    <img
                                        src={homebtn}
                                        alt=""
                                        className="backIcon"
                                        onClick={(e) => {
                                            setShowConfirmation ? confirmCancel() : goToHome()
                                        }}
                                    />
                                    <div className="vertical-line"></div>
                                    <p className="templateheading">
                                        {`Create Banner | ${editorProps?.showBannertype}`}
                                    </p>

                                    <br />
                                    {editorProps?.showAssettype === "Template" ? (
                                        <div
                                            className={
                                                editorProps?.showBannertype === "Animated"
                                                    ? "tempNamebanner"
                                                    : "tempNamebanner"
                                            }
                                        >
                                            <Tooltip title={editorProps?.showBannerName}>
                                                <h6 className="editorTemp-name">
                                                    {editorProps?.showBannerName}
                                                </h6>
                                            </Tooltip>
                                        </div>
                                    ) : (
                                        <div
                                            style={editorProps?.showBannertype === "Animated" ? { right: "139px" } : { right: "117px" }}
                                            className={
                                                editorProps?.showBannertype === "Animated"
                                                    ? "bannerNameModule"
                                                    : "bannerNameModule"
                                            }
                                        >
                                            <Tooltip title={editorProps?.showBannerName}>
                                                <h6 className="editorTemp-name">
                                                    {editorProps?.showBannerName}
                                                </h6>
                                            </Tooltip>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 editorPreviewTempheaderRight">
                        <div className="col-md-2 editorHeaderTempRight">
                            <div className="right-side">
                                <div className="promomats-text-container">
                                    <div className="source-text">Source</div>
                                    <strong>PromoMats</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BannerPreviewHeader;
